"use client";

import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect, useRef, useState } from "react";
import type { WaveMentionTypeaheadOption } from "./WaveMentionsPlugin";
import WaveMentionsTypeaheadMenuItem from "./WaveMentionsTypeaheadMenuItem";
export default function WaveMentionsTypeaheadMenu(t0) {
  const $ = _c(20);
  const {
    selectedIndex,
    options,
    setHighlightedIndex,
    selectOptionAndCleanUp,
    anchorElement
  } = t0;
  const menuRef = useRef(null);
  const [position, setPosition] = useState("bottom");
  let t1;
  if ($[0] !== anchorElement) {
    t1 = () => {
      if (globalThis.window === undefined) {
        return;
      }
      const win = globalThis.window;
      const anchorRect = anchorElement.getBoundingClientRect();
      const spaceAbove = anchorRect.top;
      const spaceBelow = win.innerHeight - anchorRect.bottom;
      const nextPosition = spaceBelow >= spaceAbove ? "bottom" : "top";
      setPosition(current => current === nextPosition ? current : nextPosition);
    };
    $[0] = anchorElement;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const updatePosition = t1;
  let t2;
  let t3;
  if ($[2] !== anchorElement || $[3] !== updatePosition) {
    t2 = () => {
      if (globalThis.window === undefined) {
        return;
      }
      const win_0 = globalThis.window;
      const cancelInitialUpdate = typeof win_0.requestAnimationFrame === "function" ? (() => {
        const frame = win_0.requestAnimationFrame(() => {
          updatePosition();
        });
        return () => {
          win_0.cancelAnimationFrame(frame);
        };
      })() : (() => {
        const timeout = win_0.setTimeout(() => {
          updatePosition();
        }, 0);
        return () => {
          win_0.clearTimeout(timeout);
        };
      })();
      win_0.addEventListener("resize", updatePosition);
      win_0.addEventListener("scroll", updatePosition, {
        passive: true
      });
      if (typeof ResizeObserver === "undefined") {
        return () => {
          cancelInitialUpdate();
          win_0.removeEventListener("resize", updatePosition);
          win_0.removeEventListener("scroll", updatePosition);
        };
      }
      const resizeObserver = new ResizeObserver(() => {
        updatePosition();
      });
      const menuElement = menuRef.current;
      if (menuElement) {
        resizeObserver.observe(menuElement);
      }
      resizeObserver.observe(anchorElement);
      return () => {
        cancelInitialUpdate();
        win_0.removeEventListener("resize", updatePosition);
        win_0.removeEventListener("scroll", updatePosition);
        resizeObserver.disconnect();
      };
    };
    t3 = [anchorElement, updatePosition];
    $[2] = anchorElement;
    $[3] = updatePosition;
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  useEffect(t2, t3);
  const t4 = `tailwind-scope tw-absolute tw-z-50 tw-w-[20rem] tw-rounded-lg tw-bg-iron-800 tw-p-2 tw-shadow-xl tw-ring-1 tw-ring-black tw-ring-opacity-5 ${position === "top" ? "tw-bottom-full tw-mb-1" : "tw-top-full tw-mt-1"}`;
  let t5;
  if ($[6] !== options || $[7] !== selectOptionAndCleanUp || $[8] !== selectedIndex || $[9] !== setHighlightedIndex) {
    let t6;
    if ($[11] !== selectOptionAndCleanUp || $[12] !== selectedIndex || $[13] !== setHighlightedIndex) {
      t6 = (option, i) => <WaveMentionsTypeaheadMenuItem key={option.key} index={i} isSelected={selectedIndex === i} onClick={() => {
        setHighlightedIndex(i);
        selectOptionAndCleanUp(option);
      }} onMouseEnter={() => {
        setHighlightedIndex(i);
      }} name={option.name} picture={option.picture} setRefElement={element => {
        option.setRefElement(element);
      }} />;
      $[11] = selectOptionAndCleanUp;
      $[12] = selectedIndex;
      $[13] = setHighlightedIndex;
      $[14] = t6;
    } else {
      t6 = $[14];
    }
    t5 = options.map(t6);
    $[6] = options;
    $[7] = selectOptionAndCleanUp;
    $[8] = selectedIndex;
    $[9] = setHighlightedIndex;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[15] !== t5) {
    t6 = <ul className="tw-mx-0 tw-mb-0 tw-flex tw-list-none tw-flex-col tw-px-2">{t5}</ul>;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== t4 || $[18] !== t6) {
    t7 = <div ref={menuRef} className={t4}>{t6}</div>;
    $[17] = t4;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  return t7;
}